module.exports = __webpack_public_path__ + "epdf-app/dashboard/envelope/envelope-3FcNnO61.html";